const RE_PLUS_SEVEN = /\+7\d{10}/;
const RE_PLUS_OTHER = /\+[12345689]\d{10,14}/;
const RE_CLEAR_CHARS = /[ \(\)\-\.]/g;

const PHONE_MASK = [
  {i: 1, ch: ' '},
  {i: 3, ch: ' ('},
  {i: 8, ch: ') '},
  {i: 13, ch: '-'},
  {i: 16, ch: '-'}
]

export function normPhone(phone: string | any) {
  if (typeof phone === 'string') {
    let p = phone.replace(RE_CLEAR_CHARS, '');
    return p;
  }
  return undefined;
}

export function wrapMask(phone: string) {
  let nPhone = normPhone(phone)
  if (nPhone) {
    for (const char of PHONE_MASK) {
      nPhone = nPhone.slice(0, char.i) + char.ch + nPhone.slice(char.i)
    }
    return nPhone
  }
  return phone;
}